import React from "react";
import { Filter, useTranslate } from 'react-admin';

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { DateTimeInput } from "components/inputs";


export const OAuth2RequestsFilter = (props) => {
	const translate = useTranslate();

	return (
		<Filter {...props}>
			<TextInputEx source="oauth2_client_name" />
			<TextInputEx source="oauth2_token_user_company_name" />
			<TextInputEx source="request_endpoint" />
			<TextInputEx source="request_method" />
			<DateTimeInput source="request_registered_at:gte" 
				withLocalTimeZone label={translate("osfc.filters.request_registered_at.from")} />
			<DateTimeInput source="request_registered_at:lte" 
				withLocalTimeZone label={translate("osfc.filters.request_registered_at.to")} />
		</Filter>
	);
};
